import { WSPage } from "@wingspanhq/fe-component-library";
import React from "react";
import { Redirect, Route, Switch } from "react-router-dom";
import { DashboardTabs } from "./DashboardTabs";
import { DashboardHeader } from "./DashboardHeader";
import { RoutePayees } from "../RoutePayees";
import {
  PAYEES_ALL_PATH,
  PAYEES_ARCHIVED_PATH,
  PAYEES_ELIGIBLE_PATH,
  PAYEES_GROUPS_LIST_PATH,
  PAYEES_INELIGIBLE_PATH,
  PAYEES_LIST_PATH,
  PAYEES_NOT_SIGNED_UP_PATH
} from "../../utils";
import { RouteGroups } from "../RouteGroups";
import { useIsEngagementsActive } from "../../../../shared/hooks/useIsEngagementsActive";

export const RoutePayeesDashboard: React.FC = () => {
  const isNewEngagements = useIsEngagementsActive();

  return (
    <WSPage>
      <DashboardHeader />
      <DashboardTabs />

      <Switch>
        {isNewEngagements ? null : (
          <Route path={PAYEES_GROUPS_LIST_PATH} component={RouteGroups} />
        )}

        <Route
          path={[
            PAYEES_ALL_PATH,
            PAYEES_INELIGIBLE_PATH,
            PAYEES_ELIGIBLE_PATH,
            PAYEES_ARCHIVED_PATH,
            PAYEES_NOT_SIGNED_UP_PATH
          ]}
          component={RoutePayees}
        />

        <Redirect to={PAYEES_ALL_PATH} />
      </Switch>
    </WSPage>
  );
};
